import { trackProductPriceClickRevenue } from './tracking';

export function logRevenueEvent(id: string, productId: number) {
  try {
    // Fetch price for the click out and log it as a Revenue event
    // to Amplitude
    fetch(`_internal/click-out-pricing/${id}`)
      .then(res => res.json())
      .then(clickPrice => {
        if (clickPrice) {
          trackProductPriceClickRevenue({
            id: productId,
            price: clickPrice,
          });
        }
      });
  } catch (err) {} // eslint-disable-line no-empty
}

export const setAntiBotFlag = (
  e:
    | React.MouseEvent<HTMLAnchorElement>
    | React.KeyboardEvent<HTMLAnchorElement>
    | React.TouchEvent<HTMLAnchorElement>
) => {
  if (!IS_BROWSER) return;

  const oldHref = e.currentTarget.href;
  const newHref = oldHref.includes('&bc=1') ? oldHref : `${oldHref}&bc=1`;

  e.currentTarget.href = newHref;
};
